import IntegrationItem from './IntegrationItem';
export default IntegrationItem;
